export enum ModalKey { 
    MOVE_FOLDER = "moveFolder"
}
